import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7b593952 from 'nuxt_plugin_plugin_7b593952' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_f24e485a from 'nuxt_plugin_pluginutils_f24e485a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2bdc7f44 from 'nuxt_plugin_pluginrouting_2bdc7f44' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_e15f905e from 'nuxt_plugin_pluginmain_e15f905e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_42d38a84 from 'nuxt_plugin_workbox_42d38a84' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_4f67e4d2 from 'nuxt_plugin_metaplugin_4f67e4d2' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_3bcd6130 from 'nuxt_plugin_axios_3bcd6130' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_bus_24831a6b from 'nuxt_plugin_bus_24831a6b' // Source: ../plugins/bus.js (mode: 'client')
import nuxt_plugin_antv_37a49fdb from 'nuxt_plugin_antv_37a49fdb' // Source: ../plugins/ant-v.js (mode: 'client')
import nuxt_plugin_log_35398f27 from 'nuxt_plugin_log_35398f27' // Source: ../plugins/log.js (mode: 'client')
import nuxt_plugin_kwaiplayerweb_3cadac0a from 'nuxt_plugin_kwaiplayerweb_3cadac0a' // Source: ../plugins/kwai-player-web.js (mode: 'client')
import nuxt_plugin_kconfserver_11649241 from 'nuxt_plugin_kconfserver_11649241' // Source: ../plugins/kconf.server.js (mode: 'server')
import nuxt_plugin_lazy_5b41718f from 'nuxt_plugin_lazy_5b41718f' // Source: ../plugins/lazy.js (mode: 'client')
import nuxt_plugin_timeonpage_169f25a6 from 'nuxt_plugin_timeonpage_169f25a6' // Source: ../plugins/time-on-page.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"kwai-nuxt-pwa-pc","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"preconnect dns-prefetch","href":"\u002F\u002Flogsdk.kwai-pro.com","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Fcdn-static.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Fak-br-pic.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Faws-pic.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Fak-cdn.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Faws-br-cdn.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Fg-br-cdn.kwai.net","crossorigin":"anonymous"},{"rel":"preconnect dns-prefetch","href":"\u002F\u002Ftx-cn-pic.kwai.net","crossorigin":"anonymous"}],"script":[{"innerHTML":"window.addEventListener(\"beforeinstallprompt\", e =\u003E {\n          \u002F\u002F Prevent Chrome 67 and earlier from automatically showing the prompt\n          e.preventDefault();\n          \u002F\u002F console.log(e.platforms);\n          \u002F\u002F e.prompt();\n          \u002F\u002F Stash the event so it can be triggered later.\n          window.deferredPrompt = e;\n          \u002F\u002F setTimeout(function() {\n          \u002F\u002F   e.prompt(); \u002F\u002F Throws if called more than once or default not prevented\n          \u002F\u002F }, 10000);\n          \u002F\u002F Update UI to notify the user they can add to home screen\n        });"},{"innerHTML":"!function(e,t){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=t():\"function\"==typeof define&&define.amd?define([],t):\"object\"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){\"undefined\"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:\"Module\"}),Object.defineProperty(e,\"__esModule\",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&\"object\"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,\"default\",{enumerable:!0,value:e}),2&t&&\"string\"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,\"a\",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p=\"\",n(n.s=0)}([function(e,t,n){\"use strict\";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r\u003Ci;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,\"__esModule\",{value:!0});var r=function(e,t,n){var o,i=e.createElement(\"script\");i.type=\"text\u002Fjavascript\",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName(\"script\")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r\u003Carguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a=\"https:\u002F\u002Fs1.kwai.net\u002Fkos\u002Fs101\u002Fnlav11187\u002Fpixel\u002Fcustom\u002Fcore-noery.js\";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c=\"?sdkid=\".concat(e,\"&lib=\").concat(n);r(t,a+c,\"https:\u002F\u002Fs16-11187.ap4r.com\u002Fkos\u002Fs101\u002Fnlav11187\u002Fpixel\u002Fcustom\u002Fcore-noery.js\"+c)}}(window,document,\"kwaiq\")}])}));kwaiq.load('244796266603650');kwaiq.page();"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7b593952 === 'function') {
    await nuxt_plugin_plugin_7b593952(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_f24e485a === 'function') {
    await nuxt_plugin_pluginutils_f24e485a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2bdc7f44 === 'function') {
    await nuxt_plugin_pluginrouting_2bdc7f44(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_e15f905e === 'function') {
    await nuxt_plugin_pluginmain_e15f905e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_42d38a84 === 'function') {
    await nuxt_plugin_workbox_42d38a84(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_4f67e4d2 === 'function') {
    await nuxt_plugin_metaplugin_4f67e4d2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3bcd6130 === 'function') {
    await nuxt_plugin_axios_3bcd6130(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bus_24831a6b === 'function') {
    await nuxt_plugin_bus_24831a6b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_antv_37a49fdb === 'function') {
    await nuxt_plugin_antv_37a49fdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_log_35398f27 === 'function') {
    await nuxt_plugin_log_35398f27(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_kwaiplayerweb_3cadac0a === 'function') {
    await nuxt_plugin_kwaiplayerweb_3cadac0a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_kconfserver_11649241 === 'function') {
    await nuxt_plugin_kconfserver_11649241(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazy_5b41718f === 'function') {
    await nuxt_plugin_lazy_5b41718f(app.context, inject)
  }

  if (typeof nuxt_plugin_timeonpage_169f25a6 === 'function') {
    await nuxt_plugin_timeonpage_169f25a6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
